import { DialogId, DialogSchema } from '@feedyou/schema'
import { FeedbotThunk } from '../../../store/types'
import { addDialogs } from '../../../actions/bot'
import { dialogsSelector } from '../selectors/dialogsSelector'
import { slugify } from '../../../lib/transliterate/slugify'

export const createNewDialog =
  (id: DialogId, additionalData?: Partial<DialogSchema>): FeedbotThunk =>
  (dispatch, getState) => {
    const dialogId = slugify(id)
    const dialogAlreadyExists = dialogsSelector(getState())[dialogId]
    if (!dialogAlreadyExists) {
      dispatch(addDialogs({ [dialogId]: { id: dialogId, steps: [], ...additionalData } }))
    }
  }
